module.exports = __webpack_public_path__ + "static/media/COS-BNB.9db3e26b.svg";